// The decorative 3D objects behind the workflow landing page — the same four purpose-made images
// and the same `.bg-object` four-corner system the pre-redesign Process Preference page used
// (recovered from commit 9748621). Styles live in components/layout.css, where the left-hand pair is
// anchored to `--sidebar-width` so they sit against the rail rather than at an arbitrary percentage.
//
// All four are `aria-hidden` with an empty alt so they never reach the accessibility tree, and
// `pointer-events: none` in CSS because the blobs overlap the cards' bounding boxes at wide
// viewports and would otherwise swallow clicks.
const DECOR = [
  { src: '/images/options_page/top_left.png', position: 'top-left' },
  { src: '/images/options_page/top_right.png', position: 'top-right' },
  { src: '/images/options_page/bottom_left.png', position: 'bottom-left' },
  { src: '/images/options_page/bottom_right.png', position: 'bottom-right' },
] as const;

export default function LandingDecor() {
  return (
    <>
      {DECOR.map(({ src, position }) => (
        <img
          key={position}
          src={src}
          alt=""
          aria-hidden="true"
          className={`bg-object ${position}`}
          loading="lazy"
          decoding="async"
        />
      ))}
    </>
  );
}
